import { z } from 'zod'
import { apiRequestMultipart } from '@/lib/api-client'

export const attachmentRefSchema = z.object({
  id: z.string(),
  filename: z.string(),
  mime: z.string(),
  size_bytes: z.number(),
  storage_path: z.string(),
  kind: z.enum(['image', 'office', 'audio', 'pdf', 'pptx', 'text']),
  extracted_text: z.string().optional(),
  transcript: z.string().optional(),
  storage_url: z.string().optional(),
  signed_url: z.string().optional(),
  parserError: z.string().optional(),
})
export type AttachmentRef = z.infer<typeof attachmentRefSchema>

export async function uploadAttachment(sessionId: string, file: File): Promise<AttachmentRef> {
  const formData = new FormData()
  formData.append('file', file)
  return await apiRequestMultipart({
    path: `/chat/sessions/${sessionId}/attachments`,
    formData,
    schema: attachmentRefSchema,
  })
}

export function isVisionMime(mime: string): boolean {
  return mime.startsWith('image/')
}

export const VISION_MODEL_DEFAULT = 'claude-sonnet-4-6'

export function modelSupportsVision(model: string): boolean {
  const lower = model.toLowerCase()
  // Konservativ: nur Claude Sonnet/Opus + GPT-4o/4-turbo + Gemini 1.5+ akzeptieren
  return (
    lower.includes('claude-sonnet') ||
    lower.includes('claude-opus') ||
    lower.includes('claude-haiku') ||
    lower.includes('gpt-4o') ||
    lower.includes('gpt-4-turbo') ||
    lower.includes('gemini-1.5') ||
    lower.includes('gemini-2')
  )
}
